import React, { useEffect, useState, useCallback } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ExampleCard from './components/ExampleCard';
import PageHeader from '../../../shared/components/BreadCrumb';

const DisponibilidadeMain = () => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <PageHeader
            title="PROGRAMAÇÃO"
            routeSegments={[
              { name: 'Início', path: '/' },
              { name: 'Programação', path: '/fornecedores' },
              { name: 'Disponibilidade' },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <ExampleCard />
      </Row>
    </Container>
  );
};

export default DisponibilidadeMain;
